import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import infoImage from '../../assets/images/infor.png';

const CToolTip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    fontSize: '11px',
    bottom: '5px',
  },
});

const CustomToolTip = props => (
  <CToolTip
    title={props?.title}
    arrow
  >
    {props.tabType ? <img alt="Info" src={infoImage} className={props.className} /> : <InfoIcon fontSize="small" color="primary" /> }
  </CToolTip>
);
export default CustomToolTip;
